import React from 'react'
import PropTypes from 'prop-types'
import { Toggle } from '@aok/ui-elements'

const OfferSearchBookmarkButton = ({ id, testId, title, isBookmarked, onClick, className }) => {
  return (
    <div
      className={`
        print:hidden
        w-48 h-48
        border-2 border-afb6bc rounded-full
        flex items-center justify-center shrink-0
        focus-visible:outline focus-visible:outline-1 focus-visible:outline-18ab42 focus-visible:outline-offset-4
        ${isBookmarked ? 'bg-005e3f  hover:bg-007141' : 'bg-ffffff hover:bg-dfe3e6 focus-visible:bg-dfe3e6 '}
        ${className}
      `}>
      <Toggle
        data-cy={testId}
        role="switch"
        type="button"
        title="Merkliste"
        aria-checked={isBookmarked}
        onClick={(e) => {
          e.stopPropagation();
          onClick(id, isBookmarked);
        }}
     />
     <span className="sr-only">{isBookmarked ? `${title} in Merkliste gespeichert` : `${title} nicht in Merkliste gespeichert`}</span>
    </div>
  )
}

OfferSearchBookmarkButton.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  isBookmarked: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  testId: PropTypes.string,
}

OfferSearchBookmarkButton.defaultProps = {
  isBookmarked: false,
  className: '',
}

export default OfferSearchBookmarkButton
